import React from 'react'

export const NewRegisterButton = ({ showModal, setShowModal }) => {

    return (
        <button className="btn btn-success py-2 ms-1 w-100 rounded-3" onClick={() => { setShowModal(!showModal) }}>
            <span className="mdi mdi-plus me-2"></span>Nuevo Registro
        </button>
    )

}
